import { useMemo } from 'react';
import { GridProps } from '../interfaces';
import { getArrayByNumber } from '../utils';

export const usePagination = ({ total, skip, pageSize }: GridProps) => {
  const pagesCount = useMemo(() => {
    if (!total || !pageSize) {
      return 0;
    }
    return Math.ceil(total / pageSize);
  }, [total, pageSize]);

  const activePageIndex = useMemo(() => {
    if (!skip || !pageSize) {
      return 0;
    }
    return skip / pageSize;
  }, [skip, pageSize]);

  const pagesItems = useMemo(() => {
    if (pagesCount < 8) {
      return getArrayByNumber(pagesCount);
    }

    const prev = activePageIndex - 1;
    const next = activePageIndex + 1;
    const last = pagesCount - 1;

    const arr: number[] = [];

    switch (prev) {
      case -1:
        arr.push(activePageIndex, next, next + 1, next + 2, next + 3, next + 4, next + 5, 0.111);
        break;
      case 0:
        arr.push(prev, activePageIndex, next, next + 1, next + 2, next + 3, next + 4, 0.111);
        break;
      case 1:
        arr.push(prev - 1, prev, activePageIndex, next, next + 1, next + 2, next + 3, 0.111);
        break;
      case 2:
        arr.push(prev - 2, prev - 1, prev, activePageIndex, next, next + 1, next + 2, next + 3, 0.111);
        break;
      default:
        switch (activePageIndex) {
          case last:
            arr.push(0.111, prev - 5, prev - 4, prev - 3, prev - 2, prev - 1, prev, last);
            break;
          case last - 1:
            arr.push(0.111, prev - 3, prev - 2, prev - 1, prev, activePageIndex, next);
            break;
          case last - 2:
            arr.push(0.111, prev - 4, prev - 3, prev - 2, prev - 1, prev, activePageIndex, next, last);
            break;
          default:
            arr.push(0.111, prev - 2, prev - 1, prev, activePageIndex, next, next + 1, next + 2, 0.111);
            break;
        }
        break;
    }
    return arr;
  }, [activePageIndex, pagesCount]);

  return {
    pagesCount,
    activePageIndex,
    pagesItems,
  };
};
